// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__E5uf+","franceConnect":"Login_franceConnect__2B4qg"};